module.exports = __webpack_public_path__ + "img/84.9e5e1f5a.jpg";